module.exports = __webpack_public_path__ + "img/rnd_pt_cors_bolts.prt.4591ab67.jpg";